import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
  user: {
    fullName: string;
    email: string;
    profile_image_url: string | null;
    username: string | undefined;
    firstName: string;
    lastName: string;
    role: string;
    cognitoSub: string;
    permissions: string[];
    isSuperAdmin: boolean;
    isAdmin?: boolean;
  };
}

const initialState: AuthState = {
  user: {
    fullName: sessionStorage.getItem('full-name') || '',
    role: sessionStorage.getItem('user-role') || '',
    cognitoSub: sessionStorage.getItem('cognitoSub') || '',
    email: '',
    profile_image_url: null,
    username: '',
    firstName: '',
    lastName: '',
    permissions: JSON.parse(sessionStorage.getItem('user-permissions') || '[]'),
    isSuperAdmin: sessionStorage.getItem('is-super-admin') === 'true',
    isAdmin: sessionStorage.getItem('is-admin') === 'true',
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const {
        cognitoSub,
        firstName,
        fullName,
        lastName,
        role,
        email,
        profile_image_url,
        userName,
        permissions,
        isSuperAdmin,
        isAdmin,
      } = action.payload;

      state.user = {
        fullName,
        lastName,
        role,
        email,
        profile_image_url,
        username: userName,
        cognitoSub,
        firstName,
        permissions: permissions ?? [],
        isSuperAdmin: Boolean(isSuperAdmin),
        isAdmin: Boolean(isAdmin),
      };
    },
  },
});

export const { setUser } = authSlice.actions;
export default authSlice.reducer;
